/*    
<summary>
  This functional component "BusinessTypeSettingPopupHOC" provides props to the child component.
  1. State "showBusinessTypeSettingPopup" that manages the show/hide of pop up
  2. Function "BusinessTypeSettingPopupToggleHandler" to toggle the show/hide popup state "showBusinessTypeSettingPopup"
  Developer:Ashutosh Modgil, Created Date:28-Aug-2022, Last Updated By: Mohammad Saquib Khan, Updated Date:26-Oct-2022
</summary>
<returns>Returns JSX</returns>
*/

import React, { useState } from "react";

const BusinessTypeSettingPopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showBusinessTypeSettingPopup, setShowBusinessTypeSettingPopup] =
      useState<boolean>(false);

    const businessTypeSettingToggleHandler = () => {
      setShowBusinessTypeSettingPopup(!showBusinessTypeSettingPopup);
    };

    return (
      <Component
        showBusinessTypeSettingPopup={showBusinessTypeSettingPopup}
        businessTypeSettingPopupToggleHandler={businessTypeSettingToggleHandler}
        {...props}
      />
    );
  };

export default BusinessTypeSettingPopupHOC;
